import { CalendarToday } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

import { DATE_TIME_FORMAT_NO_TIME, formatDate } from '../modules/date-helpers';

import IconValue from './IconValue';

type CarDetailTileFirstRegProps = {
  firstRegistration?: string;
  constructionYear?: number;
};

const CarDetailTileFirstReg = ({ firstRegistration, constructionYear }: CarDetailTileFirstRegProps) => {
  const { t } = useTranslation();
  return (
    <IconValue
      icon={CalendarToday}
      label={t('car.firstRegistration')}
      padding
      hint={constructionYear && `${t('car.constructionYear')}: ${constructionYear}`}
    >
      {formatDate(firstRegistration || '', DATE_TIME_FORMAT_NO_TIME)}
    </IconValue>
  );
};

export default CarDetailTileFirstReg;
